import React from 'react';
import {Yandex} from "../yandex-ads";

export default function DeliveryGroupList({groupName, deliveriesItems}) {

    return (
        <div className="application-block">
            <Yandex renderTo="rtb-1" />
           {/*  <h1 className="group-name">{groupName}</h1> */}
            {deliveriesItems}
        </div>
    );
}
